import styled from "styled-components";

export const LiveCasinoGridItemTitleDefaultBox = styled.div`
  padding: 0.5em 1em;
  font-size: 1.2em;
  color: ${props => props.theme.colors.buttonLight};
  background-color: ${props => props.theme.colors.buttonDark};
  letter-spacing: 1px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  @media ${({theme}) => theme.mediaQuery.sAndBelow} {
    padding: 0.25em 0.5em;
  }
`;